module.exports = __webpack_public_path__ + "img/LocumBucks.b13f25a9.jpg";